var _path, _path2, _path3, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkSupplierHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    viewBox: "0 0 81 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9983 33.3411V53.1266H71.0666H53.2032H44.2715V30.6431V16.2537H67.4939C67.4939 16.2537 68.4077 23.5005 71.0666 27.0458C73.6324 30.467 79.9983 33.3411 79.9983 33.3411Z",
    fill: "#EC187B",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9896 0.932861V16.2224V30.6125V53.097H36.7773H1.03271V0.932861H43.9896Z",
    fill: "#FDE8F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40088 53.0947H15.6916M44.2731 16.2217H67.4955C67.4955 16.2217 68.4094 23.4685 71.0682 27.0138C73.6341 30.435 79.9999 33.3091 79.9999 33.3091V53.0947H71.0682M44.2731 16.2217V0.932861H25.7472M44.2731 16.2217V30.6111V53.0947M44.2731 53.0947H33.555M44.2731 53.0947H53.2048",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6231,
    cy: 55.8623,
    rx: 8.93171,
    ry: 8.99341,
    fill: "#FDE8F2",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.1387,
    cy: 55.8623,
    rx: 8.93171,
    ry: 8.99341,
    fill: "#FDE8F2",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkSupplierHover);
export default __webpack_public_path__ + "static/media/bulkSupplierHover.b10620d618b1b84296986f50e0f3d5ae.svg";
export { ForwardRef as ReactComponent };